import React from 'react';

import { ToastContainer } from 'react-toastify';
import MainRoutes from './routes/MainRoutes';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <MainRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        theme="colored"
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
